import React from "react";
import PropTypes from "prop-types";
import { controlPropTypes } from "../formhelpers";
import DropdownWrapper from "../../components/DropdownWrapper";

export const ENTER_KEY = "Enter";
export const SPACE_KEY = " ";

const toIconNode = (icon, placeholder=false) => {
    if (placeholder && !icon) {
        icon = "placeholder";
    }
    return typeof icon === "string"
        ? <span key="icon" className={`glyphicon glyphicon-${icon}`} />
        : (icon || <span />);
};

export default class Button extends React.Component {
    constructor(props) {
        super(props);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onHide = this.onHide.bind(this);

        // for buttons with dropdown options
        this.buttonRef = React.createRef();
        this.dropdownRef = React.createRef();
        this.hasOptions = this.hasOptions.bind(this);
        this.state = {
            showDropdownMenu: false,
        };
    }

    onKeyDown(e) {
        const {descriptor, onKeyDown, value} = this.props;
        const key = e.key;
        if (key === ENTER_KEY || key === SPACE_KEY) { // enter
            this.onClick(e);
            e.preventDefault();
            e.stopPropagation(); // prevents dropdown from immediately being closed
            return;
        }
        onKeyDown && onKeyDown(e, descriptor, value, false);
    }

    onClick(e, v) {
        e.preventDefault();
        if (v && v.disabled) return;
        const { descriptor, enabled, onClick, options, collapse } = this.props;
        if (!enabled) return;
        const hasOptions = this.hasOptions();
        let value = this.props.value;
        if(hasOptions) {
            if(hasOptions === 1 && collapse) {
                v = options[0];
            }
            if(v === undefined) {
                // no value means toggle dropdown
                this.setState(s => ({showDropdownMenu: !s.showDropdownMenu}));
                return;
            }
            value = v;
        }
        onClick && onClick(e, descriptor, value);
        this.setState(s => s.showDropdownMenu ? {showDropdownMenu: false} : null); // hide dropdown menu after click.
    }

    onFocus(e) {
        const { descriptor, onFocus, value } = this.props;
        onFocus && onFocus(e, descriptor, value);
    }

    onBlur(e) {
        const { descriptor, onBlur, value } = this.props;
        onBlur && onBlur(e, descriptor, value);
    }

    onHide() {
        this.setState({showDropdownMenu: false});
    }

    hasOptions() {
        const { options = [] } = this.props;
        return options ? options.length : 0;
    }

    render() {
        const {
            id,
            value,
            label,
            options,
            enabled,
            className = "focusable btn btn-widget",
            icon = null,
            dropdownCarrot,
            dataAlign,
            autoSize,
            collapse,
            anchorRef,
            ddActionName,
        } = this.props;
        const hasOptions = collapse ? this.hasOptions() > 1 : !!this.hasOptions();
        const v = typeof value === "string" ? value : "";
        const button = <button
            id={id}
            ref={anchorRef || this.buttonRef}
            type="button"
            className={className + (hasOptions ? " dropdown-toggle" : "")}
            onClick={this.onClick}
            onKeyDown={this.onKeyDown}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            disabled={!enabled}
            value={v}
            data-control-type={hasOptions ? "bootstrap-dropdown" : ""}
            data-dd-action-name={ddActionName}
        >
            {toIconNode(icon)}
            {" "}
            {label || v}
            {dropdownCarrot && hasOptions && [" ", <span key="caret" className="caret" />]}
        </button>;

        if(!hasOptions) {
            return button;
        }

        const hasIcons = options.some(o => o.icon);
        return (
            <React.Fragment>
                {button}
              {this.state.showDropdownMenu && enabled && <DropdownWrapper
                    targetRef={anchorRef || this.buttonRef}
                    dropdownRef={this.dropdownRef}
                    onHide={this.onHide}
                    align={dataAlign}
                    autoSize={autoSize || false}
                >
                    <ul className="dropdown-menu" ref={this.dropdownRef}>
                        {options.map((option, idx) => {
                            let label = option.label;
                            if (hasIcons) {
                                label = [
                                    toIconNode(option.icon, true),
                                    " ",
                                    label,
                                ];
                            }
                            return <li
                                key={option.value || idx}
                                onClick={option.disabled ? undefined : (e) => this.onClick(e, option)}
                                className={option.disabled ? "disabled" : undefined}
                            >
                                <a
                                    tabIndex="-1"
                                    href="#"
                                    data-key={option.value}
                                >
                                    {label}
                                </a>
                            </li>;
                        })}
                    </ul>
                </DropdownWrapper>
              }
            </React.Fragment>
        );
    }
}

Button.defaultProps = {
    dropdownCarrot: true,
    label: "",
    value: "",
    collapse: true,
};

Button.propTypes = {
    ...controlPropTypes(null, false),
    onCommitChange: PropTypes.func,
    onClick: PropTypes.func.isRequired,
    value: PropTypes.any,
    label: PropTypes.node,
    options: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.node,
        label: PropTypes.node.isRequired,
        value: PropTypes.any.isRequired
    })),
    dropdownCarrot: PropTypes.bool,
    collapse: PropTypes.bool,
    dataAlign: PropTypes.string,
    anchorRef: PropTypes.object, // ref for anchoring the dropdown
};




// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/Button.js